module.exports = __webpack_public_path__ + "img/t4-t2.41ec70bc.svg";